import React, {useState, createContext} from 'react';

import game_minecraft from '@/images/games/minecraft.jpg';
import game_hytale from '@/images/games/hytale.png';
import game_fivem from '@/images/games/fivem.png';
import game_rust from '@/images/games/rust.jpg';
import game_unturned from '@/images/games/unturned.jpg';
import game_cs from '@/images/games/cs.png';
import game_ark from '@/images/games/ark.jpg';
import game_roblox from '@/images/games/roblox.png';
import game_gmod from '@/images/games/gmod.png';
import game_custom from '@/images/games/custom.png';
import {loadSnapshot} from "@/lib/utils";

const snapshot = loadSnapshot();
export const initialState= snapshot?.state || {
  welcome: true,
  apiKey: null,
  game: null,
  loginProvider: null,
  admin: {
    username: null,
    realname: null,
    email: null,
    password: null,
    confirmPassword: null,
    avatar: null,
  },
  games: [
    {
      id: "minecraft",
      name: "Minecraft",
      image: game_minecraft,
      loginProviders: ["default", "minecraft", "xbox"]
    },
    {
      id: "hytale",
      name: "Hytale",
      image: game_hytale,
      loginProviders: ["hytale", "default"]
    },
    {
      id: "fivem",
      name: "FiveM",
      image: game_fivem,
      loginProviders: ["cfx", "steam", "discord", "default"]
    },
    {
      id: "rust",
      name: "Rust",
      image: game_rust,
      loginProviders: ["steam"]
    },
    {
      id: "ark",
      name: "ARK: Survival Evolved",
      image: game_ark,
      loginProviders: ["steam"]
    },
    {
      id: "cs",
      name: "Counter-Strike",
      image: game_cs,
      loginProviders: ["steam"]
    },
    {
      id: "gmod",
      name: "Garry's Mod",
      image: game_gmod,
      loginProviders: ["steam"]
    },
    {
      id: "unturned",
      name: "Unturned",
      image: game_unturned,
      loginProviders: ["steam"]
    },
    {
      id: "roblox",
      name: "Roblox",
      image: game_roblox,
      loginProviders: ["roblox", "discord", "default"]
    },
    {
      id: "custom",
      name: "Custom",
      image: game_custom,
      loginProviders: ["default", "steam", "discord"]
    }
  ]
}

const InstallerContext = createContext();

export function InstallerProvider({children}) {
  const [data, setData] = useState(initialState);
  
  const updateData = (newData) => {
    setData({
      ...data,
      newData,
    });
  }
  
  const updatePathKeyValue = (path, key, value) => {
    setData({
      ...data,
      [path]: {
        ...data[path],
        [key]: value,
      },
    });
  }
  
  const updateAdminData = (key, value) => {
    updatePathKeyValue('admin', key, value);
  }
  
  const setWelcome = (value) => {
    setData({
      ...data,
      welcome: value,
    });
  }
  
  const setApiKey = (value) => {
    setData({
      ...data,
      apiKey: value,
    });
  }
  
  const setGame = (value) => {
    setData({
      ...data,
      game: value,
    });
  }
  
  const setLoginProvider = (value) => {
    setData({
      ...data,
      loginProvider: value,
    });
  }
  
  const value = {
    data,
    setData,
    updateData,
    setWelcome,
    setApiKey,
    setGame,
    setLoginProvider,
    updateAdminData,
  };
  return <InstallerContext.Provider value={value}>{children}</InstallerContext.Provider>;
}

export default InstallerContext;